<template>
  <div>
    <Frame>
      <template v-slot:header>
        <div class="search-box">
          <div class="left">
            <van-field
              v-model="fieldValue"
              is-link
              readonly
              label="班级"
              placeholder="请选择班级"
              @click="show = true"
            />
            <van-popup v-model:show="show" round position="bottom">
              <van-cascader
                v-model="cascaderValue"
                title="请选择班级"
                :options="optionsCascader"
                @close="show = false"
                style="background: #fff"
                @finish="onFinish"
                :field-names="{
                  text: 'name',
                  value: 'id',
                  children: 'child'
                }"
              />
            </van-popup>
            <!-- <van-search
              v-model="searchName"
              shape="round"
              placeholder="请输入搜索关键词"
              style="height: 36px; line-height: 28px; padding-right: 12px"
              @search="searchEvt"
            /> -->
            <!-- <van-field
  v-model="fieldValue"
  is-link
  readonly
  label="校区"
  placeholder="请选择班级"
  @click="show = true"
/>
<van-popup v-model:show="show" round position="bottom">
  <van-cascader
    v-model="cascaderValue"
    title="请选择班级"
    :options="options"
    @close="show = false"
    @finish="onFinish"
  />
</van-popup> -->
          </div>
          <div class="right">
            <van-image
              width="24"
              height="24"
              :src="require('@/assets/image/common/filter.png')"
              @click="showDialog"
            />
          </div>
        </div>
        <!-- <div class="header-filter">
        <van-image
          width="24"
          height="24"
          :src="require('@/assets/image/common/filter.png')"
          @click="showDialog"
        />
      </div> -->
      </template>
      <template v-slot:body>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :finished-text="
              finished && list.length >= 10 ? '--没有更多了--' : ''
            "
            @load="onLoad"
          >
            <RecordItemteacher
              :key="index"
              :detail="item"
              v-for="(item, index) in list"
              @navigate="navigateDetail"
            />
            <van-empty
              v-if="list.length <= 0 && finished"
              class="custom-image"
              :image="require('@/assets/image/no-data.png')"
              description="暂无数据"
            />
          </van-list>
        </van-pull-refresh>
      </template>
      <template v-slot:footer>
        <div class="footer">
          <FilterDialog
            v-if="filterDialogShow"
            title="搜索"
            @right="filterDialogCancleEvt"
            @reset="filterDialogResetEvt"
            @ok="filterDialogOkEvt"
          >
            <van-search
              v-model="searchName"
              shape="round"
              placeholder="请输入搜索姓名"
              style="height: 36px; line-height: 28px; padding-right: 12px"
              @search="searchEvt"
            />
            <FilterStatusList
              ref="statusFilter"
              title="筛选"
              :default-ids="searchStatus"
              :list="filterList"
            />
          </FilterDialog>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "@/components/frame.vue";
import RecordItemteacher from "./recordItemteacher.vue";
import FilterDialog from "@/components/filterDialog.vue";
// import FilterStatusList from "./filterStatusList.vue";
import FilterStatusList from "@/components/filterStatusList.vue";

import { Toast, Cascader, Popup } from "vant";

import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  name: "RecordList",
  components: {
    Frame,
    RecordItemteacher,
    FilterDialog,
    FilterStatusList,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const show = ref(false);
    const fieldValue = ref("");
    const cascaderValue = ref("");
    const deptType = ref("");
    const optionsCascader = ref([]);
    const searchName = ref("");
    const organizationId = ref("");
    // 选项列表，children 代表子选项，支持多级嵌套
    // 全部选项选择完毕后，会触发 finish 事件
    const onFinish = ({ selectedOptions }) => {
      show.value = false;
      fieldValue.value = selectedOptions.map(v => v.name).join("/");
      organizationId.value = selectedOptions[selectedOptions.length - 1].id;
      deptType.value='class'
      getApplyList();
      console.log("onFinish===", selectedOptions);
    };

    const handleTreeData = data => {
      data.forEach(item => {
        if (item.child && item.child.length) {
          handleTreeData(item.child);
        } else {
          item.child = null;
        }
      });
    };

    const treeAndAllUser = params =>
      store.dispatch("common/treeAndAllUser", params);
    const getTreeAndAllUser = async () => {
      // const data = [
      //   {
      //     name: "浙江省",
      //     id: "330000",
      //     child: [{ name: "杭州市", id: "330100", child: [] }]
      //   },
      //   {
      //     name: "江苏省",
      //     id: "320000",
      //     child: [
      //       { name: "南京市", id: "320100", list: [{ name: "xxx", id: 123 }] }
      //     ]
      //   }
      // ];
      // handleTreeData(data);
      // optionsCascader.value = data;
      let params = {
        isAuth: true
      };
      let r = await treeAndAllUser(params);
      console.log("----getTreeAndAllUser-----", r);
      handleTreeData(r.data.list);
      optionsCascader.value = r.data.list;
    };
    getTreeAndAllUser();

    const statusFilter = ref(null);

    // 筛选列表
    const filterList = ref([]);
    const statusList = params =>
      store.dispatch("studentLeave/statusList", params);
    const getFilterList = async () => {
      let r = await statusList();
      if (r.message === "success") {
        let list = r.data.list;
        list.map(item => {
          let temp = {
            name: item.name,
            value: item.code
          };
          filterList.value.push(temp);
        });
      } else {
        Toast.fail(r.message);
      }
    };
    getFilterList();

    const filterDialogShow = ref(false);
    const filterDialogCancleEvt = () => {
      filterDialogShow.value = false;
    };
    const filterDialogResetEvt = () => {
      statusFilter.value.resetEvt();
    };
    const filterDialogOkEvt = () => {
      pageIndex = 1;
      list.value = [];
      searchStatus.value = statusFilter.value
        ? statusFilter.value.activeIds
        : "";
      getApplyList();
      filterDialogShow.value = false;
    };
    const showDialog = () => {
      filterDialogShow.value = true;
    };

    // 消息列表
    let pageIndex = 1;
    let pageSize = 30;
    const searchStatus = ref();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);

    const searchEvt = () => {
      list.value = [];
      pageIndex = 1;
      getApplyList();
    };
    const onLoad = () => {
      getApplyList();
    };

    // 下拉刷新
    const onRefresh = () => {
      // 清空列表数据
      list.value = [];
      pageIndex = 1;
      finished.value = false;
      onLoad();
    };

    // 获取申请列表
    const applyList = params =>
      store.dispatch("studentLeave/studentLeaveClassRecord", params);
    const getApplyList = async () => {
      let params = {
        bizType: "student_leave", // 业务类型 学生请假
        searchStatusList: searchStatus.value,
        pageNo: pageIndex,
        pageSize: pageSize,
        searchName: searchName.value,
        organizationId: organizationId.value,
        deptType:deptType.value
      };
      
      console.log("params", params);
      setTimeout(() => {
        loading.value = false;
        finished.value = true;
      }, 3000);
      let r = await applyList(params);
      if (r.message == "success") {
        if (refreshing.value) {
          list.value = [];
          refreshing.value = false;
        }
        list.value.push(...r.data.list);
        loading.value = false;
        pageIndex++;
        if (list.value.length >= r.data.total) {
          finished.value = true;
        }
      } else {
        refreshing.value = false;
        finished.value = true;
        loading.value = false;
        Toast.fail(r.message);
      }
    };
    getApplyList();

    // 跳转到详情页
    const navigateDetail = detail => {
      console.log("lllll");
      router.push({
        path: "/leaveDetail",
        query: {
          detail: detail
        }
      });
    };

    return {
      show,
      onFinish,
      fieldValue,
      cascaderValue,
      deptType,
      optionsCascader,
      organizationId,
      searchName,
      searchEvt,
      searchStatus,
      statusFilter,
      filterDialogShow,
      filterDialogCancleEvt,
      filterDialogResetEvt,
      filterDialogOkEvt,
      showDialog,
      onRefresh,
      filterList,
      list,
      loading,
      finished,
      refreshing,
      navigateDetail
    };
  }
};
</script>

<style lang="less" scoped>
.header-filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 46px;
  padding: 0 15px;
}
.search-box {
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #fff;
  .left {
    flex: 1;
  }
  .right {
    display: flex;
    width: 63px;
    text-align: center;
  }
}
</style>
